export default __webpack_public_path__ + "static/bg-teste-arabe-104aac5e6980e4e9e65eed9f4b9e0620.svg";